import { render, staticRenderFns } from "./TypePictureWord.vue?vue&type=template&id=67df206c&"
import script from "./TypePictureWord.vue?vue&type=script&lang=js&"
export * from "./TypePictureWord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports